// eslint-disable-next-line capitalized-comments, no-inline-comments
function noop() { /* empty */ }

module.exports = noop